import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import theme from './theme';
import './i18n/config';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import LanguageHandler from './components/LanguageHandler';
import Home from './pages/Home';
import Experiences from './pages/Experiences';
import About from './pages/About';
import Contact from './pages/Contact';
import BookExperience from './pages/BookExperience';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LegalAdvise from './pages/LegalAdvise';
import CookiesPolicy from './pages/CookiesPolicy';

const App: React.FC = () => {

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <LanguageHandler />
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          minHeight: '100vh'
        }}>
          <Header />
          <Box component="main" sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/:lang" element={<Home />} />
              <Route path="/experiences" element={<Experiences />} />
              <Route path="/:lang/experiences" element={<Experiences />} />
              <Route path="/about" element={<About />} />
              <Route path="/:lang/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/:lang/contact" element={<Contact />} />
              <Route path="/book-experience" element={<BookExperience />} />
              <Route path="/:lang/book-experience" element={<BookExperience />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/:lang/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/legal-advise" element={<LegalAdvise />} />
              <Route path="/:lang/legal-advise" element={<LegalAdvise />} />
              <Route path="/cookies-policy" element={<CookiesPolicy />} />
              <Route path="/:lang/cookies-policy" element={<CookiesPolicy />} />
            </Routes>
          </Box>
          <Footer />
          <CookieConsent />
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default App; 